import React from 'react';

import ConfirmationDialog from 'views/widgets/ConfirmationDialog.jsx';

export default function UnsavedChangesDialog(props) {

	const { yesCallback, noCallback } = props;

	return (
		<ConfirmationDialog
			title={"Unsaved Changes"}
			prompt="Changes will be lost. Are you sure you want to continue?"
			yesCallback={yesCallback}
			noCallback={noCallback}
			cancelCallback={noCallback}
		/>
	);
}